import React from 'react'
import styles from './styles/info-boxes-wrapper.module.scss'

/**
  Creates two col layout for infoBoxes 
*/

const InfoBoxesWrapper = ({ children }) => {
	return (
		<div className={styles.infoBoxesWrapper}>
			{children}
		</div>
	)
}

export default InfoBoxesWrapper;